<template>
  <div
    class="iq-card-header w-100"
    v-if="
      showSearchBox ||
        (userBusinesses && userBusinesses.length > 1) ||
        (userBranches && userBranches.length > 1)
    "
  >
    <div class="iq-card-body">
      <div class="iq-card">
        <div class="d-flex align-items-center justify-content-between p-2">
          <!-- Search -->
          <div v-show="showSearchBox" class="ais-SearchBox-form" id="searchbox">
            <b-form-input
              type="search"
              v-model="search"
              placeholder="Search by name..."
              class="ais-SearchBox-input"
            ></b-form-input>
          </div>

          <div class="d-flex justify-content-around w-100">
            <!-- Business -->
            <b-form-group
              label="Select Business"
              v-show="showBusinessSelector && userBusinesses && userBusinesses.length > 1"
            >
              <b-form-select
                plain
                v-model="BusinessId"
                @change="handleBusinessChange"
              >
                <b-form-select-option
                  v-for="business in userBusinesses"
                  :key="business.id"
                  :value="business.id"
                >
                  {{ getLocalizedName(business.locales) }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>

            <!-- Branch -->
            <b-form-group
              label="Select Branch"
              v-show="showBranchSelector && userBranches && userBranches.length > 1"
            >
              <b-form-select
                plain
                v-model="BranchId"
                @change="$emit('branchChange', BranchId)"
              >
                <b-form-select-option
                  v-for="branch in userBranches"
                  :key="branch.id"
                  :value="branch.id"
                >
                  {{ getLocalizedName(branch.locales) }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchFilters",
  props: {
    searchQuery: String,
    showSearchBox: {
      type: Boolean,
      default: true, 
    },
    showBusinessSelector: {
      type: Boolean,
      default: true, 
    },
    showBranchSelector: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      BusinessId: null,
      BranchId: null,
      search: this.searchQuery,
      selectedBusiness: null,
    };
  },
  computed: {
    userBusinesses() {
      return this.$store.state.User.user.business || [];
    },
    userBranches() {
      return this.selectedBusiness ? this.selectedBusiness.branches || [] : [];
    },
  },
  watch: {
    search(newVal) {
      this.$emit("update:searchQuery", newVal);
    },
    searchQuery(newVal) {
      this.search = newVal;
    },
    userBusinesses: {
      handler(newBusinesses) {
        if (newBusinesses.length > 0 && !this.BusinessId && this.showBusinessSelector) {
          this.BusinessId = newBusinesses[0].id;
          this.handleBusinessChange(this.BusinessId);
        }
      },
      deep: true,
      immediate: true,
    },
    userBranches: {
      handler(newBranches) {
        if (newBranches.length > 0 && !this.BranchId && this.showBranchSelector) {
          this.BranchId = newBranches[0].id;
          this.$emit("branchChange", this.BranchId);
        }
      },
      deep: true,
    },
  },
  methods: {
    handleBusinessChange(businessId) {
      this.BusinessId = businessId;
      const business = this.userBusinesses.find((b) => b.id === businessId);
      this.selectedBusiness = business || null;
      this.BranchId = business?.branches?.[0]?.id || null;
      this.$emit("businessChange", businessId);
      if (this.BranchId && this.showBranchSelector) {
        this.$emit("branchChange", this.BranchId);
    }
  },
  getLocalizedName(locales) {
      const locale = this.$i18n.locale || "en";
      const localizedData =
        locales.find(l => l.locale === locale) || locales[0];
      return localizedData ? localizedData.name : "No Name";
    },
}
}
</script>

<style scoped></style>